module.exports = __webpack_public_path__ + "19948f0e694c874ca48a9037bdb51bcc.jpg";